import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import PreschoolPage from "@/pages/PreschoolPage";
import SpecialEdPage from "@/pages/SpecialEdPage";
import GoalsPage from "@/pages/GoalsPage";
import PhilosophyPage from "@/pages/PhilosophyPage";
import ContactPage from "@/pages/ContactPage";
import OurApproachPage from "@/pages/OurApproachPage";
import TermDatesPage from "@/pages/TermDatesPage";
import TwoKPage from "@/pages/TwoKPage";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Defer to let target page render
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App font-body" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programs/preschool" element={<PreschoolPage />} />
            <Route path="/programs/preschool/2k" element={<TwoKPage />} />
            <Route path="/programs/special-education" element={<SpecialEdPage />} />
            <Route path="/approach" element={<OurApproachPage />} />
            <Route path="/term-dates" element={<TermDatesPage />} />
            <Route path="/goals" element={<GoalsPage />} />
            <Route path="/philosophy" element={<PhilosophyPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
